export const SALARY_ROUTE_NAMES = {
    LIST: "SalaryList",
    HISTORY: "SalaryHistory",
    EDIT: "SalaryEdit",
};
